import * as React from "react";
import { Accordion, AccordionDetails, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import CustomAccordionSummary from "./partial/accordion-summary";

interface IMyAccordionProps {
  id: string | number;
  summary: React.ReactNode;
  children: React.ReactNode;
  expanded?: boolean;
  onToggleExpand?: () => void;
}

const MyAccordion: React.FunctionComponent<IMyAccordionProps> = ({
  id,
  summary,
  children,
  expanded,
  onToggleExpand,
}) => {


  // const handleChangeExpand = React.useCallback(() => {
  //   setExpanded((crt) => !crt);
  // }, []);
  //Getting translation object
  
  const { t } = useTranslation();

  return (
    <Box>
      <Accordion square={true} expanded={expanded} id={`panel${id}d-accordion`}>
        {/*Accordion Summary part */}
        <CustomAccordionSummary
          expanded={expanded}
          handleChange={onToggleExpand}
        >
          {summary}
        </CustomAccordionSummary>
        {/*Accordion Summary part */}
        <AccordionDetails>{children}</AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default MyAccordion;
